
const builder = {
    state: {
        currentStep: 1,
        resumeData: {
            profile: {
                id: null,

                firstName: null,
                lastName: null,
                email: null,
                professionalEmail: null,
                portfolioLink: null,
                linkedinLink: null,
                phone: null,
                address1: null,
                address2: null,
                city: null,
                state: null,
                zip: null,
                country: null,
                summary: null
            },
            educations: [{
                university: null,
                degree: null,
                major: null,
                minor: null,
                description: null,
                city: null,
                state: null,
                country: null,
                startDate: null,
                endDate: null,
                isGraduated: 1,
                cgpa: 0.00,
                fgpa: 4.00
            }],
            experiences: [{
                company: null,
                position: null,
                description: null,
                city: null,
                state: null,
                country: null,
                startDate: null,
                endDate: null,
                isCurrent: 1
            }],
            projects: [{
                name: null,
                description: null,
                startDate: null,
                endDate: null,
                portfolioLink: null
            }],
            certificates: [{
                name: null,
                description: null,
                awardedBy: null,
                receivedDate: null
            }],
            skills: [{
                name: null,
                description: null,
                proficiency: null
            }],
            summary: ''
        }
    },
    mutations: {
        updateStep(state, step) {
            state.currentStep = step
        },
        updateProfile(state, data) {
            state.resumeData.profile = { ...data }
        },
        updateEducation(state, educationList) {
            state.resumeData.educations = [...educationList]
        },
        updateExperience(state,experienceList) {
            state.resumeData.experiences = [...experienceList]
        },
        updatePoject(state, projectList) {
            state.resumeData.projects = [...projectList]
        },
        updateCertificate(state, certificateList) {
            state.resumeData.certificates = [...certificateList]
        },
        updateSkill(state, skillList) {
            state.resumeData.skills = [...skillList]
        },
    },
    actions: {
        saveAndProceed({ commit }, { section, data, index }) {
            if (section === 'profile') {
                commit('updateProfile', data)
            }else if(section === 'education') {
                commit('updateEducation', data)
            }else if (section === 'experience') {
                commit('updateExperience',  data )
            }else if (section === 'project') {
                commit('updatePoject',  data )
            }else if(section === 'certificate') {
                commit('updateCertificate', data)
            }else if(section === 'skill') {
                commit('updateSkill', data)
            }


            // Add similar handling for other sections
        }
    },
    getters: {
        resumeData: (state) => state.resumeData,
    }
}

export default builder
